export type TenantMemberStatus = 'Active' | 'Invited'
export type TenantMemberRole = 'Admin' | 'Viewer'

export type TenantMemberSortColumn = 'userName' | 'email' | 'role' | 'status' | 'joined'

export const TENANT_MEMBER_DEFAULT_SORT_DIRECTIONS: Record<TenantMemberSortColumn, 'asc' | 'desc'> = {
  userName: 'asc',
  email: 'asc',
  role: 'asc',
  status: 'asc',
  joined: 'asc',
}

export interface TenantMember {
  id: string
  tenantId: string
  tenantName: string
  entraObjectId: string
  role: TenantMemberRole
  status: TenantMemberStatus
  joinedAt: string | null
  invitedEmail: string
  displayName: string
}

export interface InviteTenantUserRequest {
  email: string
  role: TenantMemberRole
}

export interface InviteTenantUserResponse {
  id: string
  tenantId: string
  role: string
  status: string
}
